import { Dialog, Grid, Typography, Paper } from '@material-ui/core'
import { Button } from 'components'
import { useState } from 'react'

import { useStyles } from './styles'

interface Props {
  open: boolean
  handleClose: (value: any) => void
  initialState: any
  confirm: () => void
  text: string
}

export const DialogConfirm = (props: Props) => {
  const { open, handleClose, initialState, confirm, text } = props
  const [isLoading, setIsLoading] = useState(false)
  const classes = useStyles()

  const handleCloseModal = () => {
    handleClose(initialState)
  }

  const handleConfirmDialog = async () => {
    setIsLoading(true)
    await confirm()
    setIsLoading(false)
    handleCloseModal()
  }

  return (
    <Dialog open={open} onClose={handleCloseModal} className={classes.root}>
      <Paper className={classes.paper}>
        <Grid>
          <Grid item xs={12}>
            <Typography className={classes.title}>Confirmação</Typography>
          </Grid>

          <Grid item xs={12} className={classes.box}>
            <Typography>{text}?</Typography>
          </Grid>

          <Grid container item xs={12} className={classes.boxBtn}>
            <Grid item>
              <Button onClick={handleCloseModal}>Cancelar</Button>
            </Grid>
            <Grid item>
              <Button
                isDelete
                onClick={handleConfirmDialog}
                isLoading={isLoading}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Dialog>
  )
}
